<div class="content">
  <div class="scored-compasses"  *ngIf="scoredCompasses">
    <div class="scored-compass" *ngFor="let scoredCompass of scoredCompasses">
      <div class="right-arrow"  (click)="showAssessmentOrEdit(scoredCompass)">
        <button  mat-icon-button >
          <mat-icon >chevron_right</mat-icon>
        </button>
      </div>
      <span class="compass-letters" [style.background-color]="getColorFromName(scoredCompass.compassName)"  (click)="showAssessmentOrEdit(scoredCompass)">{{getLetters(scoredCompass.compassName)}}</span>
      <div class="compass-text"  (click)="showAssessmentOrEdit(scoredCompass)">
        <div class="compass-title">{{scoredCompass.compassName}}</div>
        <div class="compass-sub-title" *ngIf="scoredCompass.lastAssessmentDay && scoredCompass.lastAssessmentDay > 0">Completed:<br>{{epochDayToDate(scoredCompass.lastAssessmentDay)}}</div>
        <div class="compass-desc">
          <div *ngIf="scoredCompass.recommendation && scoredCompass.userDate != 'Not yet taken'"><strong>{{scoredCompass.recommendation}}</strong> Overall score: {{scoredCompass.score}}</div>
          <div *ngIf="family">For: {{scoredCompass.userFriendlyName}}</div>
          <div *ngIf="!family">Published by: {{scoredCompass.publishingProviderName}}</div>
          <div>Version: {{getVersion(scoredCompass.bulkSubscriptionId)}}</div>
          <div>Assessed by:{{scoredCompass.assigningProviderUsername}}</div>

        </div>
      </div>
      <div class="button-container">
        <button  type="button" *ngIf="userIsAssessmentTaker(scoredCompass)" class="docs-button"  (click)="takeAssessment(scoredCompass)" mat-icon-button  matTooltip="Take assessment for the patient">
          <mat-icon>psychology_alt</mat-icon>
        </button>
        <button type="button" *ngIf="userIsAssessmentTaker(scoredCompass)" class="docs-button"  (click)="log(scoredCompass)" mat-icon-button matTooltip="Log for the patient">
          <mat-icon>checklist</mat-icon>
        </button>
        <button class="docs-button"  type="button"  (click)="showDocuments(scoredCompass)" mat-icon-button 
        matTooltip="Manage patient documents">
          <mat-icon  svgIcon="lib_books"></mat-icon>
        </button>

      </div>
    </div>
  </div>
</div>
<div class="add-new-container">
  <button mat-fab color="primary" (click)="editAssignment(null)">
 + Add new
  </button>
</div>